// src/SpinnerComponent.js
import React from 'react';
import { HashLoader } from 'react-spinners';
import { css } from '@emotion/react';
import styles from './componentStyles';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const SpinnerComponent = ({ loading }) => {
    return (
        <div className="sweet-loading">
            <HashLoader
                color="blue"
                loading={loading}
                css={override}
                size={80}
                style={styles.sweetLoading()} />
        </div>
    );
};

export default SpinnerComponent;